import { useAuth } from "../contexts/AuthContext";
import ClubDashboard from "../Components/ClubDashboard";
import PublicHome from "../Components/PublicHome";
import "../assets/css/Home.css";

const Home = () => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <main className="club-dashboard club-dashboard-auth-loading" aria-busy="true">
                <div className="club-dashboard-container">
                    <div className="club-dashboard-auth-header">
                        <span />
                        <span />
                        <span />
                    </div>
                    <div className="club-dashboard-auth-cards">
                        <span /><span /><span /><span />
                    </div>
                </div>
            </main>
        );
    }

    return user ? <ClubDashboard user={user} /> : <PublicHome />;
};

export default Home;
